export const suppliers = (state) => state.suppliers
export const selectAllField = (state) => state.selectAllField
export const selectedSuppliers = (state) => state.selectedSuppliers
export const totalSuppliers = (state) => state.totalSuppliers
export const viewSupplier = (state)=>state.viewSupplier